import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=584b0000&"
import script from "./Legal.vue?vue&type=script&lang=js&"
export * from "./Legal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/links/Legal.vue
// module id = null
// module chunks = 